export const capitalizeFirst = (text: string): string => `${text.charAt(0).toUpperCase()}${text.slice(1)}`;
